<template>
  <div :class="listClasses">
    <ul :class="itemsClasses">
      <slot></slot>
    </ul>
  </div>
</template>
<script>
import { PREFIX_CLASS } from '../../utils/constants'
import bus from '../../utils/bus'
import {
  BUS_LIST_ITEM__ASK,
  BUS_LIST__VALUE_CHANGE,
  BUS_LIST__REGISTER,
  BUS_LIST__UNREGISTER,
  FILTER_MATCHED,
  FILTER_NOT_MATCHED,
  FILTER_RESET
} from './constants'
const PREFIX_LIST_CLASS = `${PREFIX_CLASS}list`

export default {
  name: 'TList',
  provide() {
    return {
      owner: this
    }
  },
  props: {
    value: {
      type: [String, Number, Boolean, Object, Array, Date, Function, Symbol],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    filterValue: {
      type: [String, Number, Boolean, Object, Array, Date, Function, Symbol],
      default: null
    },
    stripe: {
      type: Boolean,
      default: false
    },
    filter: {
      type: Function,
      default: function (itemLabel, itemValue, filterValue) {
        return itemLabel.toLocaleLowerCase().indexOf(filterValue.toLocaleLowerCase()) >= 0
      }
    }
  },
  data() {
    return {
      hasValueProp: false,
      currentValue: null,
      currentActivedIndex: -1,
      items: [] // 存储实例以提升查询性能
    }
  },
  computed: {
    itemsClasses() {
      return [
        `${PREFIX_LIST_CLASS}__options`
      ]
    },
    listClasses() {
      return [
        `${PREFIX_LIST_CLASS}`,
        {
          [`${PREFIX_LIST_CLASS}--stripe`]: this.stripe
        }
      ]
    }
  },
  watch: {
    filterValue(val) {
      if (val === '' || val === null || val === undefined) {
        this.$_resetFilter()
      } else {
        this.$_filterItems(val)
      }
    },
    value: {
      handler(val) {
        this.currentValue = this.normalizeValue(val)
      },
      immediate: true
    },
    currentValue(val) {
      bus.$emit(BUS_LIST__VALUE_CHANGE, this, val)
    },
    items (val) {
      this.$emit('item-change')
    }
  },
  created() {
    bus.$on(BUS_LIST__REGISTER, this.$_onBusRegister)
    bus.$on(BUS_LIST__UNREGISTER, this.$_onBusUnregister)
    bus.$on(BUS_LIST_ITEM__ASK, this.$_onBusListItemAsk)
  },
  beforeDestroy() {
    this.items = null
  },
  methods: {
    fireActivedClick() {
      if (this.currentActivedIndex >= 0) {
        this.items[this.currentActivedIndex].fireClick()
      }
    },
    unactived() {
      this.$_setActived(this.currentActivedIndex, false)
      this.currentActivedIndex = -1
    },
    $_setActived(itemIndex, actived) {
      if (itemIndex >= 0 && itemIndex < this.items.length) {
        this.items[itemIndex].focused = actived
        if (actived) {
          this.currentActivedIndex = itemIndex
        }
      }
    },
    nextActived() {
      this.$_setActived(this.currentActivedIndex, false)
      let idx = this.currentActivedIndex + 1
      console.log('idx===>', idx)
      if (idx >= this.items.length) {
        idx = 0
      }
      this.$_setActived(idx, true)
    },
    prevActived() {
      this.$_setActived(this.currentActivedIndex, false)
      let idx = this.currentActivedIndex - 1
      if (idx < 0) {
        idx = this.items.length - 1
      }
      this.$_setActived(idx, true)
    },
    $_onBusRegister(owner, item) {
      if (this === owner) {
        this.$_registerItem(item)
      }
    },
    $_onBusUnregister(owner, item) {
      if (this === owner) {
        this.$_unregisterItem(item)
      }
    },
    reset() {
      this.items.forEach(item => {
        item.show()
      })
      this.currentValue = this.multiple ? [] : ''
    },
    $_resetFilter() {
      this.reset()
      this.$emit('filter', FILTER_RESET)
    },
    $_filterItems(val) {
      if (this.filter) {
        let matched = false // 是否匹配到了项
        for (let i = this.items.length - 1; i >= 0; i--) {
          let item = this.items[i]
          if (this.filter(item.finalLabel, item.value, val) === true) {
            item.show()
            matched = true
          } else {
            item.hide()
          }
        }
        this.$emit('filter', matched ? FILTER_MATCHED : FILTER_NOT_MATCHED)
      }
    },
    /**
     * 注册`TListItem`子组件,该方法仅供`TListItem`子组件使用！
     * @private
     * @param {TListItem} item `TListItem`子组件实例
     */
    $_registerItem(item) {
      if (item.$options.name === 'TListItem') {
        this.items.push(item)
      }
    },
    /**
     * 注销`TListItem`子组件,该方法仅供`TListItem`子组件使用！
     * @private
     * @param {TListItem} item `TListItem`子组件实例
     */
    $_unregisterItem(item) {
      if (item.$options.name === 'TListItem' && Array.isArray(this.items)) {
        this.items.splice(this.items.indexOf(item), 1)
      }
    },
    /**
     * 检测指定的值是否存在与现有的`TListItem`实例值相匹配的项。
     * @param {*} val 除数组以外的任意非空类型值
     * @returns {Object|null} 如果存在匹配项返回一个包含`value`和`label`属性的简单对象，否则返回`null`，如果值是`null`或`undefined`或数组返回`null`
     */
    $_includesValue(val) {
      if (this.$_isEmpty(val) || Array.isArray(val)) {
        return null
      }
      const finalValue = (typeof val === 'object') ? val.value : val
      for (let i = this.items.length - 1; i >= 0; i--) {
        const itemValue = this.items[i].value
        if (itemValue === finalValue) {
          return {
            value: itemValue,
            label: this.items[i].finalLabel
          }
        }
      }
      return null
    },
    $_normalizeObjectValue(val) {
      if (typeof val !== 'object') {
        val = {
          label: '',
          value: val
        }
      }
      if (val.hasOwnProperty('label') === false) {
        val.label = ''
      }
      if (val.hasOwnProperty('value') === false) {
        val.value = val
      }
      return val
    },
    $_isEmpty(val) {
      return val === null || val === undefined
    },
    /**
     * 将输入值转为正确格式。
     * @param {*} val 值。
     * @returns 返回规范后的值数据，该数据在`multiple`为`false`时是一个简单对象(`plain object`)，该对象包含两个属性：`label`和`value`，如果原始值没有`label`属性将会被补上一个值为空串`''`的`label`属性，如果原始值没有`value`属性将会被补上一个值为原始值本身的`value`属性；该数据在`multiple`为`true`时是一个由前述简单对象组成的数组。
     */
    normalizeValue(val) {
      if (this.multiple === true) {
        if (Array.isArray(val)) {
          let finalValue = val.map(item => {
            return this.$_includesValue(item) // normalizeObjectValue(item)
          })
          return finalValue
        } else {
          let result = this.$_includesValue(val)
          if (result === null) {
            return []
          } else {
            return [result]
          }
        }
      } else {
        return this.$_includesValue(val)
      }
    },
    $_getValue(item) {
      return {
        value: item.value,
        label: item.finalLabel.replace(/^\s+/, '').replace(/\s+$/, '')
      }
    },
    /**
     * `g-list-item_ask`总线事件响应函数
     * @private
     * @param {TList} owner `TList`实例ID，即触发该事件的`TListItem`的所属父组件实例
     * @param {TListItem} item 触发该事件的`TListItem`实例
     * @param {Boolean} wantChecked 将要切换到的选择状态
     */
    //   $_onBusListItemAsk(owner, item, wantChecked) {
    //     if (owner === this) {
    //       if (this.multiple === false) {
    //         this.currentValue = this.$_getValue(item)
    //         this.inside = true // 标识从组件内部修改value属性的值
    //         let checkedIndex = 0
    //         this.$children.forEach((child, i) => {
    //           if (child.checked) {
    //             checkedIndex = i
    //           }
    //         })
    //         this.$emit('input', this.currentValue)
    //         this.$emit('update:value', this.currentValue)
    //         this.$emit('change', this.currentValue, checkedIndex)
    //       } else {
    //         let val = this.$_getValue(item)
    //         var tempCurrentValue = this.currentValue.concat()
    //         if (wantChecked === true) {
    //           // item.check(true)
    //           if (tempCurrentValue.includes(val) === false) {
    //             tempCurrentValue.push(val)
    //           }
    //         } else {
    //           // item.uncheck(true)
    //           let idx = -1
    //           for (let i = tempCurrentValue.length - 1; i >= 0; i--) {
    //             if (tempCurrentValue[i].label === val.label && tempCurrentValue[i].value === val.value) {
    //               idx = i
    //               break
    //             }
    //           }
    //           if (idx >= 0) {
    //             tempCurrentValue.splice(idx, 1)
    //           }
    //         }
    //         this.currentValue = tempCurrentValue
    //         this.inside = true // 标识从组件内部修改value属性的值
    //         this.$emit('input', tempCurrentValue)
    //         this.$emit('update:value', tempCurrentValue)
    //         this.$emit('change', tempCurrentValue)
    //       }
    //     }
    //   }
    // }

    $_onBusListItemAsk(owner, item, wantChecked) {
      if (owner !== this) return
      if (this.multiple === false) {
        this.currentValue = this.$_getValue(item)
        let checkedIndex = 0
        this.$children.forEach((child, i) => {
          if (child.checked) {
            checkedIndex = i
          }
        })
        this.$emit('input', this.currentValue)
        this.$emit('update:value', this.currentValue)
        this.$emit('change', this.currentValue, checkedIndex)
      } else {
        let val = this.$_getValue(item)
        var tempCurrentValue = this.currentValue.concat()
        if (wantChecked === true) {
        // item.check(true)
          if (tempCurrentValue.includes(val) === false) {
            tempCurrentValue.push(val)
          }
        } else {
        // item.uncheck(true)
          let idx = -1
          for (let i = tempCurrentValue.length - 1; i >= 0; i--) {
            if (tempCurrentValue[i].label === val.label && tempCurrentValue[i].value === val.value) {
              idx = i
              break
            }
          }
          if (idx >= 0) {
            tempCurrentValue.splice(idx, 1)
          }
        }
        this.currentValue = tempCurrentValue
        this.$emit('input', tempCurrentValue)
        this.$emit('update:value', tempCurrentValue)
        this.$emit('change', tempCurrentValue)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/list/list.vue